import { createFileRoute } from '@tanstack/react-router';
import { PersonalInfoTab } from '@/features/auth/components/personal-info-tab/PersonalInfoTab';

export const Route = createFileRoute('/_authenticated/profile/personal-info')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="mt-6">
      <PersonalInfoTab />
    </div>
  );
}
